import React from 'react';

const mqttContext = React.createContext({});

export default mqttContext;
